export const escapeRegExp = (text: string):string => text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');

export const isObject = (variable: any):boolean => {
  return Object.prototype.toString.call(variable) === '[object Object]';
};

export const isEmptyObject = (value: any):boolean => {
  return isObject(value) && Object.keys(value).length === 0;
};